import axiosBase from "@/api/axiosBase";

const state = {
    globalStyle: {},
    //     '子流域': {
    //         'bzField':'subbasin',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 1)',

    //         'fillCate':1,
    //         'fillColor':'subbasinColorBar',
    //         'fillOpacity':0.3,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': false,
    //         'strokeColor': 'rgba(188, 188, 188, 0.8)'
    //     },
    //     '子河道': {
    //         'bzField':'rchid',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 1)',

    //         'fillCate':1,
    //         'fillColor':'riverColorBar',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColor': 'rgba(255, 0, 0, 0.8)'
    //     },
    //     '气象': {
    //         'bzField':'name',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 1)',

    //         'fillCate':1,
    //         'fillColor':'red-green-blue',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(255, 0, 0, 0.8)',
    //         'pMark':3,
    //         'pSize':10
    //     },
    //     '点源': {
    //         'bzField':'name',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 1)',

    //         'fillCate':1,
    //         'fillColor':'red-green-blue',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(255, 0, 0, 0.8)',
    //         'pMark':4,
    //         'pSize':10
    //     },
    //     '河道抽水': {
    //         'bzField':'name',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 1)',

    //         'fillCate':1,
    //         'fillColor':'red-green-blue',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(255, 0, 0, 0.8)',
    //         'pMark':'circle',
    //         'pSize':10
    //     }
    // },
    sceneStyle: {}
}

const getters = {
}

const actions = {

}

const mutations = {
    setGlobalStyle(state, globalStyle){
        state.globalStyle = globalStyle;
    },
    //案例样式
    setSceneStyle(state, jsonStr){
        state.sceneStyle[jsonStr.sceneId] = jsonStr.style;
    },
    //标注显示字段更改
    setBZField(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        } 
        state.sceneStyle[changeStyle.sId][changeStyle.cate].bzField = changeStyle.value;
    },
    //标注字号更改
    setBZFontSize(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        } 
        state.sceneStyle[changeStyle.sId][changeStyle.cate].bzFontSize = changeStyle.value;
    },
    //标注颜色更改
    setBZColor(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        }
        state.sceneStyle[changeStyle.sId][changeStyle.cate].bzColor = changeStyle.value;
    },
    //样式类型更改
    setFillCate(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        }
        state.sceneStyle[changeStyle.sId][changeStyle.cate].fillCate = changeStyle.value;
    },
    //填充颜色更改
    setFillColor(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        }
        state.sceneStyle[changeStyle.sId][changeStyle.cate].fillColor = changeStyle.value;
    },
    setFillOpacity(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        }
        state.sceneStyle[changeStyle.sId][changeStyle.cate].fillOpacity = changeStyle.value;
    },
    //边线粗细更改
    setStrokeWidth(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        }
        state.sceneStyle[changeStyle.sId][changeStyle.cate].strokeWidth = changeStyle.value;
    },
    //边线颜色更改
    setStrokeColor(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        }
        state.sceneStyle[changeStyle.sId][changeStyle.cate].strokeColor = changeStyle.value;
    },
    setStrokeColorToFillColor(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        }
        state.sceneStyle[changeStyle.sId][changeStyle.cate].strokeColorToFillColor = changeStyle.value;
    },
    //点样式更改
    setPointMark(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        }
        state.sceneStyle[changeStyle.sId][changeStyle.cate].pMark = changeStyle.value;
    },
    //点大小更改
    setPointSize(state, changeStyle){
        if(!state.sceneStyle.hasOwnProperty(changeStyle.sId)){
            state.sceneStyle[changeStyle.sId] = JSON.parse(JSON.stringify(state.globalStyle));
        }
        state.sceneStyle[changeStyle.sId][changeStyle.cate].pSize = changeStyle.value;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}